import { Flex } from 'antd';
import { StyledCardRows } from './CardRows.styles';
import { CardRowsProps } from './CardRows.types';

export const CardRows = ({ title, rows }: CardRowsProps): JSX.Element => (
  <StyledCardRows>
    {title && <p className="card-rows__title">{title}</p>}
    {rows.map(({ label, value }) => (
      <Flex key={label} className="card-rows__row" gap={4}>
        <span className="card-rows__label">{label}</span>
        <span className="card-rows__value">{value}</span>
      </Flex>
    ))}
  </StyledCardRows>
);
